import Header from "../../components/layout/Header";
import PageWithAside from "../../components/layout/PageWithAside";
import BusinessWalkIn from "../../components/businessTools/BusinessWalkIn";
import Loader from "../../components/ui/Loader";
import useGetBookingType from "../../hooks/useGetBookingType";
import useToast from "../../components/ui/toasts/useToast";
import { useEffect } from "react";

const BusinessWalkInPage: React.FC = () => {
  const { loading, error, clearBookingTypeState } = useGetBookingType();
  const { notify } = useToast();

  useEffect(() => {
    if (error) {
      notify("error", error);
      clearBookingTypeState();
    }
  }, [error]);

  return (
    <PageWithAside role="business">
      <div className="wrapper">
        <Header
          pageTitle="Walk-in"
          pageDesc="You can print out the QR code for walk-in customer to scan and register"
          role="business"
        />
        {loading ? <Loader /> : <BusinessWalkIn />}
      </div>
    </PageWithAside>
  );
};

export default BusinessWalkInPage;
